export const HOURS_FETCH_REQUEST='hours-fetch-request';
export const HOURS_FETCH_SUCCESS='hours-fetch-success';
export const HOURS_FETCH_FAILURE='hours-fetch-failure';